import {
  CONTAINER_OPTIONS,
  CONTENT_LAYOUT_OPTIONS,
  HEADING_ALIGNMENT_OPTIONS,
  MODULE_FILL_TYPE_OPTIONS,
  MODULE_FLOW_DIRECTION_OPTIONS,
  TITLE_SIZE_OPTIONS,
  TITLE_TYPE_OPTIONS,
} from '@/common/constants';
import { useModuleStyles } from '@/common/hooks';
import { BaseModuleProps } from '@/common/types';
import { CTABlock } from '@/components/blocks/CTABlock';
import { HeadingBlock, HeadingBlockProps } from '@/components/blocks/HeadingBlock/HeadingBlock';
import { CTAProps } from '@/components/CTA';
import KPICard, { KPICardProps } from '@/components/KPICard/KPICard';
import React from 'react';
import styles from './KPI.module.scss';
import { SingleKPI } from './SingleKPI';

export interface KPIProps extends BaseModuleProps {
  kpi: KPICardProps[];
  kpiCtas?: CTAProps[];
  kpiCTACaption?: string;
}

export const KPI: React.FC<KPIProps> = ({
  anchorTag = undefined,
  container = CONTAINER_OPTIONS.CONTAINED,
  fillType = MODULE_FILL_TYPE_OPTIONS.BASE,
  gradientFillToken,
  eyebrow,
  title,
  titleSize = TITLE_SIZE_OPTIONS.SMALL,
  titleType = TITLE_TYPE_OPTIONS.H2,
  bodyRichTextAsHTML,
  alignment = HEADING_ALIGNMENT_OPTIONS.CENTER,
  ctas,
  caption,
  kpi,
  kpiCtas,
  kpiCTACaption,
}) => {
  const headingConfig: HeadingBlockProps = {
    eyebrow,
    title,
    titleSize,
    titleType,
    bodyRichTextAsHTML,
    alignment,
    ctas,
    caption,
  };

  const { sectionStyles, moduleBaseStyles } = useModuleStyles({
    container,
    fillType,
    gradientFillToken,
    flowDirection: MODULE_FLOW_DIRECTION_OPTIONS.COLUMN,
    layout: CONTENT_LAYOUT_OPTIONS.CONTENT_TRAILING,
    moduleClassName: 'module-kpi',
    styles,
  });

  return (
    <section className={sectionStyles} id={anchorTag}>
      <div className={moduleBaseStyles}>
        <HeadingBlock {...headingConfig} />
        <div className={styles['kpi-content-container']}>
          {kpi.length > 1 ? (
            <>
              <div className={styles.multi_kpi_container}>
                {kpi.map((kpi, idx) => (
                  <KPICard
                    key={kpi.kpiMetric + '_' + idx}
                    kpiCaption={kpi.kpiCaption}
                    kpiMetric={kpi.kpiMetric}
                    kpiLabel={kpi.kpiLabel}
                    className={styles['kpi-card-color']}
                  />
                ))}
              </div>
              {kpiCtas && <CTABlock ctas={kpiCtas} caption={kpiCTACaption} />}
            </>
          ) : (
            <SingleKPI
              kpi={kpi[0]}
              ctas={kpiCtas}
              caption={kpiCTACaption}
              className={styles['single-kpi-card-color']}
            />
          )}
        </div>
      </div>
    </section>
  );
};
